export const props = {
  values: { type: Object, default: () => ({}) },
  config: { type: Object, default: () => ({}) },
  globalData: { type: Object, default: () => ({}) },
  field: { type: Object, default: () => ({}) },
  handleChange: { type: Function, default() {} },
  handleInput: { type: Function, default() {} },
  disabled: { type: Boolean, default: false },
  setFieldValue: { type: Function, default() {} },
};
